import {
  WeightNamesMap,
  WeightValue,
} from 'common/Prose/Toolbar/components/Format/components/MainStylePane/components/FontWeight/util'
import { useFontFamily } from 'common/Prose/Toolbar/hooks/useFontFamily'
import { useFontWeight } from 'common/Prose/Toolbar/hooks/useFontWeight'
import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef } from 'react'
import { FontFamilyType } from 'utils/fontUtils'
import Styles from './FontFamilyGroup.module.scss'
import { FontFamilyContext, getStillInsideWindowClickSignaler } from './stores/FontFamilyStore'

export const FontFamilySearchInput = observer(function FontFamilySearchInput() {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const fontFamilyStore = useContext(FontFamilyContext)!
  const inputRef = useRef<HTMLInputElement>(null)
  const { setFontFamily } = useFontFamily()
  const { setFontWeight } = useFontWeight()

  useEffect(() => {
    const isMine = getStillInsideWindowClickSignaler(inputRef)
    fontFamilyStore.registerWindowClickSignaler(isMine)
    return () => fontFamilyStore.unregisterWindowClickSignaler(isMine)
  })

  useEffect(() => {
    if (inputRef.current && fontFamilyStore.showingFontFamilyDropdown) {
      inputRef.current.focus()
      inputRef.current.setSelectionRange(0, inputRef.current.value.length)
    }
  }, [inputRef, fontFamilyStore.showingFontFamilyDropdown])

  const handleClick = (e: React.MouseEvent) => {
    if (inputRef.current && fontFamilyStore.showingFontFamilyDropdown) {
      e.preventDefault()
      inputRef.current.focus()
      inputRef.current.setSelectionRange(0, inputRef.current.value.length)
    }
  }

  const handleChange = () => {
    if (!inputRef.current) return
    fontFamilyStore.searchValue = inputRef.current.value
    fontFamilyStore.softOpen()
  }

  const handleFocus = () => {
    fontFamilyStore.softOpen()
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ('Enter' === e.key) {
      e.preventDefault()
      fontFamilyStore.selectAndClose((fontFamily: FontFamilyType, weight: WeightValue) => {
        setFontFamily(fontFamily)
        setFontWeight(WeightNamesMap[weight])
      })
    }
    if ('ArrowDown' === e.key) {
      fontFamilyStore.selectNext()
    }
    if ('ArrowUp' === e.key) {
      fontFamilyStore.selectPrevious()
    }
    if ('ArrowRight' === e.key) {
      fontFamilyStore.goDeeper()
    }
    if ('ArrowLeft' === e.key) {
      fontFamilyStore.goShallower()
    }
  }

  return (
    <input
      style={{ fontFamily: fontFamilyStore.firstActiveFontDefinition }}
      className={Styles.searchInput}
      data-testid="fontFamily-input"
      ref={inputRef}
      value={fontFamilyStore.searchValue || fontFamilyStore.firstActiveFontDefinition}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onKeyDown={handleKeyDown}
    />
  )
})
